import { render } from "./AssetType_Devices.vue?vue&type=template&id=5ed42132&ts=true"
import script from "./AssetType_Devices.vue?vue&type=script&lang=ts"
export * from "./AssetType_Devices.vue?vue&type=script&lang=ts"

import exportComponent from "/data/jenkins/workspace/PROD/SwissApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__